import { useI18n } from '../../index';

/**
 * A custom hook to fetch a specific section of translations for the first available locale.
 * It also merges common translations available in the locale.
 *
 * @param {string} key - The key for the specific section of translations to retrieve.
 * @returns {object} The translation section merged with common translations.
 */
const useSiteTranslation = (key: string) => {
  // Retrieve the translations from the I18n context
  const { translations } = useI18n();

  // Determine the first locale key available in the translations object
  const selectedLocaleKey = Object.keys(translations)[0];

  // Guard clause to handle when no locales are present
  if (!selectedLocaleKey) {
    console.warn('No locales found in translations.');
    return {};
  }

  // Access the translation data for the selected locale
  const selectedLocaleData = translations[selectedLocaleKey];

  // Attempt to retrieve the specific section of translations
  const section = selectedLocaleData[key];

  // Guard clause to handle when the desired translation section is not found
  if (!section) {
    console.warn(`Translation section "${key}" not found in locale "${selectedLocaleKey}".`);
    return {};
  }

  // Merge the specific section with common translations if available
  return {
    ...section,
    ...selectedLocaleData['common'], // Merge common translations, assuming 'common' holds shared translations
  };
};

export default useSiteTranslation;
